import { Box } from '@mui/material';
import { lighten } from '@mui/material/styles';
import looksLikeDate from 'components/@home/drawers/HrBotDrawer/XMLViewer/looksLikeDate';
import PropTypes from 'prop-types';
import React from 'react';

const Attributes = ({ attributes = null, theme, onClick = null, xpath }) => {
  const attributeList = [];
  const overflow = theme.overflowBreak ? { overflowWrap: 'break-word', whiteSpace: 'normal' } : {};
  const link = typeof onClick === 'function';
  for (const key in attributes) {
    const value = attributes[key]?.trim();
    const dateLike = looksLikeDate(value);
    attributeList.push(
      <span key={`attr-${key}[${attributes[key]}]`}>
        <span style={{ color: theme.attributeKeyColor }}>{` ${key}`}</span>
        <span style={{ color: theme.separatorColor }}>=</span>
        <span style={{ color: theme.attributeValueColor }}>
          <span>&quot;</span>
          {dateLike ? (
            attributes[key].split(/[-/]/).map((part, partIndex) => (
              <Box
                key={`${key}-${partIndex}`}
                component="span"
                sx={[
                  { borderRadius: '4px', p: '2px' },
                  link && {
                    cursor: 'pointer',
                    backgroundColor: '#eaeaac',
                    '&:hover, &:focus': {
                      backgroundColor: lighten('#ffffbb', 0.02),
                    },
                  },
                  !link && {
                    '&:hover, &:focus': {
                      backgroundColor: 'inherit',
                    },
                  },
                ]}
                onClick={() =>
                  onClick(
                    `${xpath}/tokenize(text(), '[-/]' )[position() = ${partIndex + 1}]`,
                    attributes[key],
                  )
                }
              >
                {`${partIndex > 0 ? '-' : ''}${part}`}
              </Box>
            ))
          ) : (
            <Box
              component="span"
              sx={[
                { borderRadius: '4px', p: '2px' },
                link && {
                  cursor: 'pointer',
                  backgroundColor: '#eaeaac',
                  '&:hover, &:focus': {
                    backgroundColor: lighten('#ffffbb', 0.02),
                  },
                },
                !link && {
                  '&:hover, &:focus': {
                    backgroundColor: 'inherit',
                  },
                },
              ]}
              onClick={() =>
                typeof onClick === 'function' && onClick(`${xpath}/@${key}`, attributes[key])
              }
            >
              ${attributes[key]}
            </Box>
          )}
          <span>&quot;</span>
        </span>
      </span>,
    );
  }

  return <span style={overflow}>{attributeList}</span>;
};

Attributes.propTypes = {
  attributes: PropTypes.object,
  theme: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  xpath: PropTypes.string.isRequired,
};

export default Attributes;
